module.exports = __webpack_public_path__ + "static/media/home_carousel_2E.87a8e971.png";